import logo from "../images/Green@small-bold.png";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useSignup } from "../../hooks/useSignup";

const Signup = ({ setShowLearn }) => {
  const [userObject, setUserObject] = useState({
    location: "Parsons",
    survey: "",
  });
  const [phonePermission, setPhonePermissions] = useState(true);
  const [emailPermission, setEmailPermissions] = useState(true);
  const [locations, setLocations] = useState([]);
  const [isLoadingLocations, setIsLoadingLocations] = useState(true);
  const [locationsError, setLocationsError] = useState(null);
  const [survey, setSurvey] = useState([]);
  const [isLoadingSurvey, setIsLoadingSurvey] = useState(true);
  const [surveyError, setSurveyError] = useState(null);

  const { error, signup } = useSignup();

  useEffect(() => {
    const fetchLocations = async () => {
      setIsLoadingLocations(true);
      setLocationsError(null);
      try {
        let dropLocationUrl = "/api/dropLocations/signup";

        if (process.env.NODE_ENV === "development") {
          dropLocationUrl = `${process.env.REACT_APP_NETWORK}${dropLocationUrl}`;
        }
        // Replace with your actual API endpoint for locations
        const response = await fetch(dropLocationUrl);
        if (!response.ok) {
          throw new Error("Failed to fetch locations");
        }

        const data = await response.json();

        setLocations(data);
      } catch (err) {
        setLocationsError(err.message);
      } finally {
        setIsLoadingLocations(false);
      }
    };

    fetchLocations();

    const fetchSurvey = async () => {
      setIsLoadingSurvey(true);
      setSurveyError(null);
      try {
        let routeUrl = "/api/routes/signup";

        if (process.env.NODE_ENV === "development") {
          routeUrl = `${process.env.REACT_APP_NETWORK}${routeUrl}`;
        }
        const response = await fetch(routeUrl);
        if (!response.ok) {
          throw new Error("Failed to fetch survey");
        }

        const data = await response.json();

        console.log(data);
        setSurvey(data);
      } catch (err) {
        setSurveyError(err.message);
      } finally {
        setIsLoadingSurvey(false);
      }
    };

    fetchSurvey();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    userObject.permissions = { phone: phonePermission, email: emailPermission };
    userObject.accountType = "Individual";

    signup(userObject);
    setShowLearn(true);
  };

  return (
    <div className="login grid">
      <img src={logo} alt="" className="logo" />
      <h3>Create your account</h3>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          onChange={(e) =>
            setUserObject({ ...userObject, firstName: e.target.value })
          }
          placeholder="First Name"
          autoComplete="on"
          required
        />
        <input
          type="text"
          onChange={(e) =>
            setUserObject({ ...userObject, lastName: e.target.value })
          }
          placeholder="Last Name"
          autoComplete="on"
          required
        />
        <input
          type="email"
          onChange={(e) =>
            setUserObject({ ...userObject, email: e.target.value })
          }
          placeholder="Email"
          autoComplete="on"
          required
        />
        <input
          type="tel"
          onChange={(e) =>
            setUserObject({ ...userObject, phone: e.target.value })
          }
          placeholder="Phone Number"
          autoComplete="on"
          required
        />
        <input
          type="text"
          onChange={(e) =>
            setUserObject({ ...userObject, zipCode: e.target.value })
          }
          placeholder="Zip Code"
          autoComplete="on"
          required
        />
        <input
          type="password"
          onChange={(e) =>
            setUserObject({ ...userObject, password: e.target.value })
          }
          placeholder="Password"
          autoComplete="on"
          required
        />
        <input
          type="password"
          onChange={(e) =>
            setUserObject({ ...userObject, confirmPassword: e.target.value })
          }
          placeholder="Confirm Password"
          autoComplete="on"
          required
        />
        <label htmlFor="locations">Choose a primary location:</label>
        {isLoadingLocations && <p>Loading locations...</p>}
        {locationsError && (
          <p className="signup-error">
            Error loading locations: {locationsError}
          </p>
        )}
        {!isLoadingLocations && !locationsError && (
          <select
            id="location"
            name="locations"
            value={userObject.location} // Ensure the select reflects the current userObject.location
            onChange={(e) =>
              setUserObject({ ...userObject, location: e.target.value })
            }
            required
          >
            {locations.map((dropLocation) => (
              <option key={dropLocation._id} value={dropLocation.name}>
                {dropLocation.name}
              </option>
            ))}
          </select>
        )}
        <label htmlFor="survey">How did you hear about us?:</label>
        {isLoadingSurvey && <p>Loading survey...</p>}
        {surveyError && (
          <p className="signup-error">Error loading survey: {surveyError}</p>
        )}
        {!isLoadingSurvey && !surveyError && (
          <select
            id="survey"
            name="survey"
            value={userObject.survey} // Ensure the select reflects the current userObject.location
            onChange={(e) =>
              setUserObject({ ...userObject, survey: e.target.value })
            }
            required
          >
            <option value="" disabled hidden>
              -- select an option --
            </option>
            {survey.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        )}
        <div className="permissions">
          <div>
            <h3>Contact permissions</h3>
            <p>
              (This is important so you can be notified when the order week for
              your area is open.)
            </p>
            <input
              id="phonePermission"
              type="checkbox"
              checked={phonePermission}
              onChange={() => setPhonePermissions(!phonePermission)}
            />
            <label htmlFor="phonePermission">
              I'm OK with getting a text when it's time to order.
            </label>
          </div>
          <div>
            <input
              id="emailPermission"
              type="checkbox"
              checked={emailPermission}
              onChange={() => setEmailPermissions(!emailPermission)}
            />
            <label htmlFor="emailPermission">
              I'm OK with getting an email when it's time to order.
            </label>
          </div>
        </div>

        <button className="login-button">Sign Up</button>
        {error && <p className="signup-error">{error}</p>}
        <div className="permissions">
          <p className="signup-note">
            Already have an account? {<Link to="/login">Login</Link>}{" "}
          </p>
        </div>
      </form>
    </div>
  );
};

export default Signup;
